// GENERATED FILE. Do not edit by hand. Produced by `bun run codegen`.

import Ajv from "ajv";
import addFormats from "ajv-formats";
import call from "../../sdk-helpers/call";
import { logError } from "../../sdk-helpers/shouldLog";

export type typeRoundListBody = {
  poolId: string;
  contestId: string;
  cursor?: string | null;
  limit?: number | null;
};

export type typeRoundListOutput200 = {
  error?: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data?: null | {
    items: {
      roundId: string;
      label: string;
      startDate: string;
      endDate: string;
      locked: boolean;
      iPicked: boolean;
      ordinal?: number;
      isProvisional?: boolean;
      withinAdvanceWindow?: boolean;
      gradingHoldReason?: "lateMakeupDebt" | null;
      pickStatusKnown?: boolean;
    }[];
    total: number;
    nextCursor?: string | null;
  };
};

export type typeRoundListOutput400 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export type typeRoundListOutput401 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export type typeRoundListOutput500 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export const schemaRoundListBody = {
  type: "object",
  properties: {
    poolId: { type: "string", maxLength: 3000, minLength: 1 },
    contestId: { type: "string", maxLength: 3000, minLength: 1 },
    cursor: {
      oneOf: [
        { type: "string", maxLength: 3000, minLength: 1 },
        { enum: [null] },
      ],
    },
    limit: { oneOf: [{ type: "integer" }, { enum: [null] }] },
  },
  required: ["poolId", "contestId"],
} as const;

export type SdkOptions = {
  headers?: Record<string, string>;
  apiHost?: string;
  prefix?: string;
};

let compiledValidator: ReturnType<Ajv["compile"]> | null = null;

export default function createRoundList(options: SdkOptions) {
  if (!compiledValidator) {
    const ajv = new Ajv({ strict: false });
    addFormats(ajv);
    compiledValidator = ajv.compile(schemaRoundListBody);
  }

  return async function postRoundList(
    payload: typeRoundListBody,
  ): Promise<typeRoundListOutput200 | typeRoundListOutput400> {
    const isValid = compiledValidator!(payload);
    if (!isValid) {
      logError(
        `Payload validation inside SDK method "postRoundList" failed before calling the network. #b112a6983fa5`,
        compiledValidator!.errors,
      );
      return {
        error: {
          code: "VALIDATION_ERROR",
          message: "Request payload failed schema validation.",
          details: { errors: compiledValidator!.errors, ref: "#b112a6983fa5" },
        },
        data: null,
      } as typeRoundListOutput400;
    }

    const prefix = options?.prefix ?? "";
    return (await call({
      payload,
      endpoint: `${prefix}/round/list`,
      httpMethod: "POST",
      options,
    })) as typeRoundListOutput200 | typeRoundListOutput400;
  };
}
